export default "__VITE_ASSET__DCYSlPj4__"